const state = {
    isShowModal: false,
    provinceObj:{}
  }
  
  const mutations = {
    SET_ISSHOWMODAL: (state, isShowModal) => {
      state.isShowModal=isShowModal
    },
    SET_PROVINCEOBJ: (state, provinceObj) => {
        state.provinceObj=provinceObj
      }
  }
  
  const actions = {
    //
    setIsShowModal({ commit }, Info) {
      return new Promise((resolve, reject) => {
        commit('SET_ISSHOWMODAL', Info)
        resolve()
      })
    },
    setProvinceObj({ commit }, Info) {
        return new Promise((resolve, reject) => {
          commit('SET_PROVINCEOBJ', Info)
          resolve()
        })
      }
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  